// Money and date display for the portal. Amounts are shown as stored.
export function money(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '';
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function day(v) {
  if (!v) return '';
  const s = String(v).slice(0, 10);
  const [y, m, d] = s.split('-');
  return y && m && d ? `${m}/${d}/${y}` : s;
}

const STATUS = { draft: 'Draft', sent: 'Sent', outstanding: 'Open', partially_paid: 'Partly paid', paid: 'Paid', overdue: 'Overdue', written_off: 'Written off' };
export const statusLabel = (s) => STATUS[s] || (s ? String(s).replace(/_/g, ' ') : '');

// Rule A: the sign says who owes whom. Above zero the client has credit with
// the business; below zero the client owes the business.
export function balanceLabel(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n === 0) return 'Balance: settled';
  return n > 0 ? `Credit: ${money(v)}` : `Owed: ${money(String(v).replace(/^-/, ''))}`;
}
